import { render } from "./Match.vue?vue&type=template&id=cf81eb54"
import script from "./Match.vue?vue&type=script&lang=js"
export * from "./Match.vue?vue&type=script&lang=js"

import "./Match.vue?vue&type=style&index=0&id=cf81eb54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__